import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgYoutube = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.836 0 16 7.163 0 16 0m.003 10.373h-.015l-.297.001c-.878.004-3.46.028-5.292.161-.313.037-.995.04-1.603.677-.48.486-.636 1.589-.636 1.589S8 14.095 8 15.39v1.214c0 1.295.16 2.59.16 2.59s.156 1.102.636 1.588c.608.637 1.408.617 1.764.684 1.2.114 4.931.155 5.393.16h.263c.5-.004 1.797-.015 3.165-.059l.457-.016c.611-.023 1.22-.053 1.763-.092.313-.037.995-.04 1.603-.677.48-.486.636-1.588.636-1.588s.16-1.295.16-2.59V15.39c0-1.295-.16-2.589-.16-2.589l-.008-.048c-.036-.218-.208-1.116-.628-1.541-.608-.637-1.29-.64-1.603-.677-1.832-.133-4.414-.157-5.292-.161l-.297-.001zm-1.656 3.206 4.324 2.256-4.323 2.24z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgYoutube);

export default ForwardRef;
